"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConditionOperator = void 0;
exports.ConditionOperator = {
    Eq: "eq",
    Neq: "neq",
    Gt: "gt",
    Gte: "gte",
    Lt: "lt",
    Lte: "lte",
};
